/** Prompt → visible motif. Binary stream was the only painted graphic; others must match that. */

export type MotionMotif = "binary" | "water" | "fire" | "dust" | "star" | "none";

export function inferMotionMotif(...parts: Array<string | undefined | null>): MotionMotif {
  const blob = parts
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .replace(/bianary|bianry/g, "binary");
  if (!blob.trim()) return "none";
  if (
    /binary|matrix|code rain|falling code|digits?|ones and zeros|1.?s and 0|0.?s and 1/.test(
      blob,
    )
  ) {
    return "binary";
  }
  if (
    /waterfall|water|ocean|sea|river|lake|tide|aqua|liquid|wave|current|\bstreams?\b/.test(
      blob,
    )
  ) {
    return "water";
  }
  if (/ember|flame|fire|magma|lava|inferno/.test(blob)) return "fire";
  if (/golden dust|fairy dust|glitter|sparkle|dust/.test(blob)) return "dust";
  if (/starfield|star field|constellation|night sky/.test(blob)) return "star";
  return "none";
}

export function motifGlyphs(motif: MotionMotif): string[] {
  switch (motif) {
    case "binary":
      return ["0", "1"];
    case "water":
      return ["~", "≈", "∽"];
    case "fire":
      return ["*", "·"];
    case "dust":
      return ["·", "+"];
    case "star":
      return ["✦", "·"];
    default:
      return [];
  }
}

export function motifWantsGlyphs(motif: MotionMotif): boolean {
  return motif === "binary" || motif === "water" || motif === "fire";
}
